angular.module('components.caItemGroupInline', [])
    .component('caItemGroupInline', {
        templateUrl: 'main/product/components/itemGroupInline.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            itemGroup: '=',
            vats: '<',
            variantGroups: '<'
        },
        controller: itemGroupInlineController
    });  

// @ngInject
function itemGroupInlineController() {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    function onInit() {
        vm.variantGroup1s = _.filter(vm.variantGroups, function(group) {
            if (!vm.itemGroup.mainGroup.variant1 || !group.variant) {
                return false;
            }
            return group.variant.id === vm.itemGroup.mainGroup.variant1.id;
        });

        vm.variantGroup2s = _.filter(vm.variantGroups, function(group) {
            if (!vm.itemGroup.mainGroup.variant2 || !group.variant) {
                return false;
            }

            return group.variant.id === vm.itemGroup.mainGroup.variant2.id;
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }

}
